import { render, staticRenderFns } from "./report-info.vue?vue&type=template&id=b0db918e&"
import script from "./report-info.vue?vue&type=script&lang=js&"
export * from "./report-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports